// @ts-strict-ignore
import React, { useState } from 'react'

import { USER_VIEW_TYPE_OPTIONS, UserViewType } from '@/shared/types/user-types'
import { Text } from '@/shared/ui'
import { Radio } from '@/shared/ui/radio'

import cl from './DeliveryModal.module.scss'

export const DeliveryModal = () => {
	const [viewType, setViewType] = useState<UserViewType>(UserViewType.Fiz)

	return (
		<div className={cl.deliveryModal}>
			<h1 className={cl.delivery__title}>Доставка</h1>

			<div className={cl.buttons}>
				<Radio.Group value={viewType} onChange={e => setViewType(e.target.value as UserViewType)} buttonStyle="solid">
					{USER_VIEW_TYPE_OPTIONS.map(option => (
						<Radio.Button key={option.value} value={option.value}>
							{option.label}
						</Radio.Button>
					))}
				</Radio.Group>
			</div>

			{viewType === UserViewType.Fiz && (
				<>
					<h2 className={cl.delivery__title2}>Доставка по Санкт-Петербургу</h2>
					<Text>Ежедневно с 12:00 до 20:00</Text>
					<Text>Доставка день в день возможна только для товаров весом до 15 кг</Text>
					<Text>Заказ свыше 200 000 ₽ доставляем по 100% предоплате</Text>
					<Text style={{ color: 'gray', margin: `10px 0 20px` }}>
						При весе заказа более 15 кг дополнительно оплачивается подъем до квартиры и, если проезд автомобиля к
						подъезду ограничен/невозможен, пронос до подъезда. Стоимость уточняйте при согласовании условий доставки у
						операторов контакт-центра
					</Text>

					<h2 className={cl.delivery__title2}>День в день</h2>
					<ul className={cl.list}>
						<li>
							Стоимость доставки — <b>750 ₽</b>
						</li>
						<li>Только при оформлении заказа от 15 000 ₽ до 16:30</li>
						<li>Оплата только онлайн на сайте</li>
					</ul>

					<h2 className={cl.delivery__title2}>На следующий день</h2>
					<ul className={cl.list}>
						<li>
							При заказе на сумму более 15 000 ₽ — <b>бесплатно</b>
						</li>
						<li>
							Стоимость заказа на сумму менее 15 000 ₽ — <b>600 ₽</b>
						</li>
						<li>Доставка за пределы КАД</li>
					</ul>

					<h2 className={cl.delivery__title2}>Доставка по России</h2>
					<ul className={cl.list}>
						<li>
							При заказе на сумму более 15 000 ₽ — <b>бесплатно</b>
						</li>
						<li>
							Стоимость заказа на сумму менее 15 000 ₽ — <b>600 ₽</b>
						</li>
						<li>
							<Text>Оплата только онлайн на сайте</Text>
							<br />
							<Text color="gray">
								Для крупногабаритных товаров, а также товаров из категории TV, пылесосов, электросамокатов
								и климатической техники действуют индивидуальные условия доставки. Сроки и конечная стоимость
								рассчитываются индивидуально.
							</Text>
						</li>
					</ul>

					<Text color="gray" weight="bold">
						Данные условия распространяются только на заказы, оформленные онлайн.
					</Text>
				</>
			)}

			{viewType === UserViewType.Yur && (
				<>
					<h2 className={cl.delivery__title2}>Доставка по Санкт-Петербургу в пределах КАД</h2>
					<Text>Ежедневно с 11:00 до 21:00</Text>
					<ul className={cl.list}>
						<li>
							Стоимость заказа на сумму менее 150 000 ₽ — <b>500 ₽</b>
						</li>
						<li>
							Стоимость заказа на сумму более 150 000 ₽ — <b>бесплатно</b>
						</li>
					</ul>

					<Text>За исключением крупногабаритных товаров. Подъём и пронос оплачиваются отдельно — 200 ₽ за этаж</Text>
					<ul className={cl.list}>
						<li>Оплата по счёту</li>
						<li>
							Доставка осуществляется на следующий день после зачисления оплаты на расчётный счёт поставщика, если товар
							есть на складе отгрузки. В остальных случаях сроки доставки согласовываются с менеджером.
						</li>
					</ul>

					<h2 className={cl.delivery__title2}>Доставка по Ленинградской области за пределами КАД</h2>
					<Text>Ежедневно с 11:00 до 21:00</Text>
					<ul className={cl.list}>
						<li>
							От 0 до 30 км от КАД — <b>600 ₽</b>
						</li>
						<li>
							От 30 до 60 км от КАД — <b>1 200 ₽</b>
						</li>

						<li>Оплата по счёту</li>
						<li>
							Доставка осуществляется на следующий день после зачисления оплаты на расчётный счёт поставщика, если товар
							есть на складе отгрузки. В остальных случаях сроки доставки согласовываются с менеджером.
						</li>
					</ul>

					<h2 className={cl.delivery__title2}>Доставка по России</h2>

					<ul className={cl.list}>
						<li>
							Рассчитывается индивидуально. Стоимость зависит от удалённости регионаРассчитывается индивидуально.
							Стоимость зависит от удалённости региона
						</li>
						<li>Работаем с разными транспортными компаниями: Cargo-Express, Деловые Линии, СДЭК</li>

						<li>Можем отправить заказ вашей логистической компанией</li>
					</ul>
				</>
			)}
		</div>
	)
}
